import { Model } from 'pinia-orm';
import Company from "./Company";


export default class BillingDetails extends Model {

    static get entity () {
        return 'billing-details'
    }

    static fields () {
        return {
            id: this.uid(),
            name: this.attr(''),
            email: this.attr(''),
            phone: this.attr(''),
            street: this.attr(''),
            number: this.attr(''),
            postal_code: this.attr(''),
            city: this.attr(''),
            state: this.attr(''),
            country: this.attr(''),
            vat: this.attr(''),
            pdf: this.attr(null),
            lang: this.attr(''),
            invoice_ref: this.attr(''),
            mandate_signed: this.attr(false),
            mandate_key: this.attr(null),
            company_id: this.attr(''),
            created_at: this.attr(''),
            updated_at: this.attr(''),

            company: this.belongsTo(Company, 'company_id')
        }
    }
}
